import { render } from "./CreatePlatformModal.vue?vue&type=template&id=04ed4922"
import script from "./CreatePlatformModal.vue?vue&type=script&lang=js"
export * from "./CreatePlatformModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__